import type { DeliveryType, StorageStrategy } from '../types/LoadOptions';

const DEFAULT_PRE_CONSENT_STORAGE_STRATEGY: StorageStrategy = 'none';
const DEFAULT_PRE_CONSENT_EVENTS_DELIVERY_TYPE: DeliveryType = 'immediate';

export { DEFAULT_PRE_CONSENT_STORAGE_STRATEGY, DEFAULT_PRE_CONSENT_EVENTS_DELIVERY_TYPE };
